import { Modal } from '@arco-design/web-vue';
import ValidatePhone from '@/components/phoneAuth/ValidatePhone.vue';
import BindPhone from '@/components/phoneAuth/BindPhone.vue';
import { useI18n } from 'vue-i18n';
import { useLiveAgentUnionOssCheckIfUidHasPhone } from '@/api/yapi-req';
import { useAppStore } from '@/store/app';

const NO_PHONE_ERROR_CODE = 502;

const usePhoneAuth = () => {
  const { t } = useI18n();
  const bindModalRef = ref();
  const phoneAuthModalRef = ref();
  const appStore = useAppStore();
  const showed = ref(false);

  const { run: fetchPhoneInfo } = useLiveAgentUnionOssCheckIfUidHasPhone({
    manual: true,
    onSuccess: (data) => {
      if (data) {
        appStore.setPhoneInfo(data);
      }
      showModal();
    },
    onError: (err) => {
      if (err.code === NO_PHONE_ERROR_CODE) {
        showModal();
      } else {
        Modal.warning({
          title: 'Error',
          content: t('lang560'),
        });
      }
    },
  });

  const show = async () => {
    if (showed.value) {
      return;
    }
    await fetchPhoneInfo();
  };

  const showModal = () => {
    if (showed.value) {
      return;
    }
    if (appStore.hasBindedPhone) {
      showPhoneAuthModal();
    } else {
      showBindPhoneModal();
    }
    showed.value = true;
  };

  const onClose = () => {
    showed.value = false;
  };

  const onOpen = () => {
    showed.value = true;
  };

  const showBindPhoneModal = () => {
    bindModalRef.value = Modal.open({
      title: t('lang264'),
      width: 464,
      content: () =>
        h(BindPhone, {
          onClick: () => {
            bindModalRef.value.close();
          },
        }),
      footer: false,
      simple: false,
      okText: t('lang244'),
      maskClosable: false,
      onClose,
      onOpen,
      modalClass: 'phone-auth-modal',
    });
  };

  const showPhoneAuthModal = () => {
    phoneAuthModalRef.value = Modal.open({
      title: t('lang265'),
      width: 464,
      content: () =>
        h(ValidatePhone, {
          onClick: () => {
            phoneAuthModalRef.value.close();
          },
        }),
      footer: false,
      simple: false,
      okText: t('lang244'),
      maskClosable: false,
      onClose,
      onOpen,
      modalClass: 'phone-auth-modal',
    });
  };

  const close = () => {
    if (bindModalRef.value) {
      bindModalRef.value.close();
    }

    if (phoneAuthModalRef.value) {
      phoneAuthModalRef.value.close();
    }
    showed.value = false;
  };

  return {
    show,
    close,
  };
};

export default usePhoneAuth;
